import { observer } from "mobx-react-lite"

import type { OrchestratedQuery } from "@/domains/library"
import { ForceRefreshIcon } from "@/domains/icons/huge-icons/monotone/force-refresh"

type ForceRefreshButtonProps = {
  query: OrchestratedQuery<any> | undefined
  title?: string
}

export const ForceRefreshButton = observer(({ query, title = "Refresh" }: ForceRefreshButtonProps) => {
  const isRunning = query?.isRunning ?? false

  const handleClick = () => {
    if (query) {
      query.forceExecute()
    }
  }

  return (
    <button onClick={handleClick} className="cursor-pointer text-t200 hover:text-t100" title={title} disabled={!query}>
      {isRunning ? <ForceRefreshIcon className="h-4 w-4 animate-spin" /> : <ForceRefreshIcon className="h-4 w-4" />}
    </button>
  )
})
